import { render, staticRenderFns } from "./OnboardingSidebar.vue?vue&type=template&id=e606616a&scoped=true&"
import script from "./OnboardingSidebar.vue?vue&type=script&lang=js&"
export * from "./OnboardingSidebar.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingSidebar.vue?vue&type=style&index=0&id=e606616a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e606616a",
  null
  
)

export default component.exports